import * as React from "react";
import { useSessionContext } from "supertokens-auth-react/recipe/session";
import useGetCustomerSession from "../features/upgrade/useGetCustomerSession";
import { useUserMetadata } from "../hooks/useUserMetadata";
import { CancelledSubscription } from "@/features/upgrade/CancelledSubscription";
import { UpgradeError } from "@/features/upgrade/UpgradeError";
import AppSkeleton from "@/ui/AppSkeleton";
import ActiveSubscription from "@/features/upgrade/ActiveSubscription";
import { ExpiredSubscription } from "@/features/upgrade/ExpiredSubscription";
import { useUiStore } from "@/stores/UiStore";
import { NewSubscription } from "@/features/upgrade/NewSubscription";

function Upgrade() {
  const session = useSessionContext();
  const { data: customerSession, isLoading, isError } = useGetCustomerSession();
  const darkMode = useUiStore((state) => state.darkMode);
  const toggleDarkMode = useUiStore((state) => state.toggleDarkMode);
  const { data: userMetadata, isLoading: isMetadataLoading } =
    useUserMetadata();

  React.useEffect(() => {
    if (darkMode) {
      toggleDarkMode();
    }
  }, [darkMode, toggleDarkMode]);

  const { paidPlan, isTrial } = session.accessTokenPayload;
  const { client_secret, subscription_status } = customerSession || {};
  var rewardfulReferenceId = null;
  if (window.Rewardful && window.Rewardful.referral) {
    console.log("FOUND");
    rewardfulReferenceId = window.Rewardful.referral;
  }

  if (isLoading || isMetadataLoading) return <AppSkeleton />;

  if (isError) {
    return <UpgradeError />;
  }

  // active subscription
  if (paidPlan) {
    return <ActiveSubscription />;
  }
  // new subscription
  else if (!client_secret && !subscription_status) {
    return (
      <NewSubscription
        email={userMetadata?.email}
        rewardfulReferenceId={rewardfulReferenceId}
      />
    );
  }
  // cancelled subscription
  else if (client_secret && !subscription_status) {
    return <CancelledSubscription clientSecret={client_secret} />;
  }
  // expired subscription (past due)
  else if (!client_secret && subscription_status) {
    return <ExpiredSubscription />;
  }
  // error!
  else {
    return <UpgradeError />;
  }
}

export default Upgrade;
